import * as React from "react";
import Snackbar from "@mui/material/Snackbar";
import { Alert, Button } from "@mui/material";
import { ToastContext } from "src/components/providers/toast-provider";
import { Link as RouteLink } from "react-router-dom";

const NotificationsSnackbar = () => {
    const { vertical, horizontal } = {
        vertical: "bottom",
        horizontal: "right",
    };

    const {
        message,
        severity,
        newTeamId,
        isToastTriggered,
        setIsToastTriggered,
        isPersonalMissions,
        isTeamMissions,
        missionTeamId,
    } = React.useContext(ToastContext);

    if (newTeamId) {
        return (
            <div>
                <Snackbar
                    style={{ marginBottom: 36 }}
                    anchorOrigin={{ vertical, horizontal }}
                    open={isToastTriggered}
                    autoHideDuration={6000}
                >
                    <Alert
                        onClose={() => {
                            setIsToastTriggered(false);
                        }}
                        action={
                            <Button
                                color="inherit"
                                size="small"
                                component={RouteLink}
                                to={`/teams/${newTeamId}`}
                                onClick={() => {
                                    setIsToastTriggered(false);
                                }}
                            >
                                EDIT
                            </Button>
                        }
                        severity={severity}
                        sx={{ width: "100%" }}
                    >
                        {message}
                    </Alert>
                </Snackbar>
            </div>
        );
    }
    if (isPersonalMissions) {
        return (
            <div>
                <Snackbar
                    style={{ marginBottom: 36 }}
                    anchorOrigin={{ vertical, horizontal }}
                    open={isToastTriggered}
                    autoHideDuration={6000}
                >
                    <Alert
                        onClose={() => {
                            setIsToastTriggered(false);
                        }}
                        action={
                            <Button
                                color="inherit"
                                size="small"
                                component={RouteLink}
                                to="/dashboard"
                                onClick={() => {
                                    setIsToastTriggered(false);
                                }}
                            >
                                DASHBOARD
                            </Button>
                        }
                        severity={severity}
                        sx={{ width: "100%" }}
                    >
                        {message}
                    </Alert>
                </Snackbar>
            </div>
        );
    }
    if (isTeamMissions) {
        return (
            <div>
                <Snackbar
                    style={{ marginBottom: 36 }}
                    anchorOrigin={{ vertical, horizontal }}
                    open={isToastTriggered}
                    autoHideDuration={6000}
                >
                    <Alert
                        onClose={() => {
                            setIsToastTriggered(false);
                        }}
                        action={
                            <Button
                                color="inherit"
                                size="small"
                                component={RouteLink}
                                to={`/teams/${missionTeamId}/dashboard/insights`}
                                onClick={() => {
                                    setIsToastTriggered(false);
                                }}
                            >
                                DASHBOARD
                            </Button>
                        }
                        severity={severity}
                        sx={{ width: "100%" }}
                    >
                        {message}
                    </Alert>
                </Snackbar>
            </div>
        );
    }
    return (
        <div>
            <Snackbar
                style={{ marginBottom: 36 }}
                anchorOrigin={{ vertical, horizontal }}
                open={isToastTriggered}
                autoHideDuration={6000}
            >
                <Alert
                    onClose={() => {
                        setIsToastTriggered(false);
                    }}
                    severity={severity}
                    sx={{ width: "100%" }}
                >
                    {message}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default NotificationsSnackbar;
